import type { Post } from '~/types/custom'

export const posts: Post[] = [
  {
    name: 'Day 3 at <a href="https://www.linkedin.com/company/wearedevelopers.org/" target="_blank">WeAreDevelopers</a> World Congress in Berlin',
    content: `
          Today marked the third and final day of the WeAreDevelopers festival, and it was just as incredible as expected! The atmosphere was electric, and I had an absolute blast.
          <br><br>
          I had the privilege of watching two of the most inspiring speeches of my life:
          <br><br>
          1. <a href="https://www.linkedin.com/in/douglas-crockford-724600109" target="_blank">Douglas Crockford</a> the inventor of JSON, delivered a phenomenal talk. His deep passion for the IT world was truly infectious, making it a memorable experience.<br>
          2. <a href="https://www.linkedin.com/in/martinwezowski" target="_blank">Martin Wezowski</a> Chief Futurist at SAP, closed the festival with a speech that deeply resonated with me. His insights on the future and the importance of diversity were both profound and moving.
          <br><br>
          Feeling incredibly inspired and grateful for this experience. Looking forward to applying these insights in my journey ahead!
      `,
    createdAt: '2024-07-18',
    preview: '/portfolio.rottigni.tech/static/assets/posts/wad-world-congress-douglad-crockford.jpeg',
    source:
      'https://www.linkedin.com/posts/lorenzo-rottigni_today-marked-the-third-and-final-day-of-the-activity-7220134354696503296-crhx/'
  },
  {
    name: 'Day 2 at <a href="https://www.linkedin.com/company/wearedevelopers.org/" target="_blank">WeAreDevelopers</a> World Congress in Berlin',
    content: `
          🌟 Day 2 at WeAreDevelopers Festival 🌟
          <br><br>
          What an incredible day! I had the opportunity to attend several invaluable speeches that enriched my knowledge and perspective on software development.
          <br><br>
          A highlight for me was <a href="https://www.linkedin.com/in/davidwhitney" target="_blank">David Whitney</a>’s talk on “Intentional Code”. His insights into writing purposeful and meaningful code were incredibly helpful. Another standout was the Red Hat presentation on managing applications through the Red Hat Developer Hub. It provided practical strategies that I’m excited to implement.
          <br><br>
          The coolest stand by far was <a href="https://www.linkedin.com/company/docker" target="_blank">Docker, Inc</a> They had an engaging game challenging attendees to “beat” the Docker Cloud pipeline speed, which was both fun and educational. Plus, they had fantastic gadgets and beers – definitely a crowd-pleaser. Docker continues to be one of my favorite companies, and their innovation never ceases to amaze me.
          <br><br>
          Looking forward to Day 3! 🚀
      `,
    createdAt: '2024-07-17',
    preview: '/portfolio.rottigni.tech/static/assets/posts/was-world-congress-duck.jpeg',
    source:
      'https://www.linkedin.com/posts/lorenzo-rottigni_day-2-at-wearedevelopers-festival-activity-7219756056975933442-uP1k/'
  },
  {
    name: 'Day 1 at <a href="https://www.linkedin.com/company/wearedevelopers.org/" target="_blank">WeAreDevelopers</a> World Congress in Berlin',
    content: `
          Today, <a href="https://www.linkedin.com/in/giosuedelgado/" target="_blank">Giosuè Delgado</a> and I attended the opening party at the WeAreDevelopers Festival in Berlin! We’re excited to start this journey tomorrow.
          <br><br>
          A big thank you to <a href="https://www.linkedin.com/company/vendure/" target="_blank">Vendure</a> and <a href="https://www.linkedin.com/company/deesup/" target="_blank">Deesup</a> for this amazing opportunity! ❤️
          <br><br>
          Thanks Docker, Inc for the beers 🐳🩵
      `,
    createdAt: '2024-07-16',
    preview: '/portfolio.rottigni.tech/static/assets/posts/wad-world-congress-giosue-delgado.jpeg',
    source:
      'https://www.linkedin.com/posts/lorenzo-rottigni_today-giosu%C3%A8-delgado-and-i-attended-the-activity-7219386809137393664-SEVK/'
  },
  {
    name: 'My First Raspberry',
    content: `
        🚀 Embarking on a New Journey 🚀
        <br><br>
        I’m excited to share that I’ve taken a bold step into a challenging yet rewarding project. I recently purchased my first Raspberry Pi with the goal of “downgrading” my personal bare-metal Kubernetes cluster, currently hosted on a cloud-based solution, to a more resource-efficient k3s distribution running on a cluster of Raspberry Pi’s. This transition will eliminate my monthly subscription costs and bring the infrastructure in-house.
        <br><br>
        In addition, I recently installed an FTTH solution at home, which includes a static IP address. This new setup enables me to fully undertake this migration.
        <br><br>
        There are numerous obstacles ahead, such as dealing with ARM-based/universal containerd images and managing the computing resources required for the various services I’ll need to migrate. However, I’m thrilled about the journey and the opportunity to deepen my skills in networking, Docker, and Kubernetes.
        <br><br>
        Here’s to overcoming challenges and learning along the way! 💪
      `,
    createdAt: '2024-07-10',
    preview: '/portfolio.rottigni.tech/static/assets/posts/raspberry-pi-5-setup.jpeg',
    source:
      'https://www.linkedin.com/posts/lorenzo-rottigni_embarking-on-a-new-journey-im-excited-activity-7215411036718264321-U5kb'
  },
  {
    name: 'Google Cloud Summit Milan 2024',
    content: `
        I had the incredible opportunity to attend the #GoogleCloudSummit in Milan, all thanks to my amazing company, Deesup.
        Special thanks to Daniele Ena, our co-founder, for accompanying me and making the event even more enjoyable. 🙏
        <br><br>
        The summit was super fun! We even got to throw three penalty shots at the soccer goal posts, with an AI-powered camera calculating our average precision, strength, and style. The results were printed into a soccer sticker-like format – such a unique and engaging activity! 
        We had insightful conversations with several companies and attended numerous talks focused on #AI and cloud-related topics. The discussions were inspiring and informative, providing us with valuable insights into the future of technology.
        Looking forward to leveraging these learnings at Deesup and exploring new horizons in the tech world! 
      `,
    createdAt: '2024-06-21',
    preview: '/portfolio.rottigni.tech/static/assets/posts/google-cloud-summit-milan-2024.jpeg',
    source: 'https://www.linkedin.com/posts/lorenzo-rottigni_googlecloudsummit-ai-activity-7212168692971782144-ecsS'
  },
  {
    name: 'Released vendure-scalapay package',
    content: `
      🚀 Exciting News! I'm thrilled to announce the release of my new #opensource plugin, seamlessly integrating Scalapay as a payment provider within the Vendure NestJS e-commerce framework, all while working with the incredible team at Deesup! 💳💡
      <br><br>
      This integration aims to enhance the shopping experience by providing flexible payment options for customers. Now, you can offer the convenience of Scalapay's buy now, pay later solution to your valued customers, right within your Vendure-powered store.
      <br><br>
      https://lnkd.in/eq9ANbn8
      <br><br>
      A huge greeting to the Vendure community, and a special thanks to Deesup for supporting this endeavor!🙌
      Let's continue pushing the boundaries of #ecommerce together.
      `,
    createdAt: '2023-09-15',
    preview: '/portfolio.rottigni.tech/static/assets/posts/vendure-scalapay.jpeg',
    source: 'https://www.linkedin.com/posts/lorenzo-rottigni_vendure-scalapay-activity-7105891927807381504-9Hi2'
  },
  {
    name: 'We Make Future Festival in Rimini',
    content: `
        Exciting times at Deesup! We had an amazing experience at the Web Marketing Festival in Rimini, connecting with industry experts and staying ahead of the digital marketing game. Looking forward to implementing innovative strategies and taking our brand to new heights! 🚀
      `,
    createdAt: '2023-06-17',
    preview: '/portfolio.rottigni.tech/static/assets/posts/wmf.jpeg',
    source: 'https://www.linkedin.com/posts/lorenzo-rottigni_wmf2023-activity-7075517907648045057-IxVL'
  },
  {
    name: 'RedHat Summit Milan 2024',
    content: `
      Today, I had the chance to attend the Red Hat Summit 2024 in Milan.
      <br><br>
      It was a great experience, offering valuable insights into the evolution of the web, from the Data Center Era, through the Cloud Era, and now into the AI Era.
      <br><br>
      I appreciated Red Hat’s continued focus on open source, highlighted by the introduction of new AI-driven open-source tools. The updates on OpenShift and its progress over the years were also particularly interesting.
      <br><br>
      A big thank you to Red Hat for such an inspiring event!
    `,
    createdAt: '2024-11-19',
    preview: '/portfolio.rottigni.tech/static/assets/posts/redhat-summit-milan-2024.webp',
    source:
      'https://www.linkedin.com/posts/lorenzo-rottigni_redhatsummit-opensource-ai-activity-7264723373094535168-omin'
  }
]
